import config from "../config";

export const reducerLoadInitialUserController = () => {
  let user = localStorage.getItem(config.localStorage.user);

  if (user) {
    return JSON.parse(user);
  }
  return null;
};

export const reducerLoadInitialBasicController = () => {
  let basic = localStorage.getItem(config.localStorage.basic);

  if (basic) {
    return JSON.parse(basic);
  }
  return null;
};

export const reducerLoadInitialBusinessController = () => {
  let business = localStorage.getItem(config.localStorage.business);

  if (business) {
    return JSON.parse(business);
  }
  return null;
};

export const reducerLoadInitialStepController = () => {
  let step = localStorage.getItem(config.localStorage.step);

  if (step) {
    return JSON.parse(step);
  }
  return null;
};

export const reducerLoadInitialResultController = () => {
  let result = localStorage.getItem(config.localStorage.result);

  if (result) {
    return JSON.parse(result);
  }
  return null;
};

export const reducerLoadInitialRewardController = () => {
  let reward = localStorage.getItem(config.localStorage.reward);

  if (reward) {
    return JSON.parse(reward);
  }
  return null;
};

export const reducerLoadInitialClaimedController = () => {
  let claimed = localStorage.getItem(config.localStorage.claimed);

  if (claimed) {
    return JSON.parse(claimed);
  }
  return null;
};
